import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import { css } from '@emotion/react';

import { useIllustrationUrl } from '../../components/Illustrations/hooks/useIllustrationUrl.hook';
import { DarkMapIllustration } from '../../components/Illustrations/DarkMap/DarkMap';

import { Avatar } from '../Avatar';

import {
  DEFAULT_STATIC_MAP_HEIGHT,
  ADDRESS_CARD_SIZE,
  ADDRESS_CARD_SX,
} from './constants/card.constant';

interface Props {
  readonly onStartCreate: () => void;
}

const newAddressString = 'Ajouter une nouvelle adresse';

export const NewAddressCard = ({
  onStartCreate: handleStartCreate,
}: Readonly<Props>) => {
  const imageUrl = useIllustrationUrl(DarkMapIllustration);

  return (
    <Grid size={ADDRESS_CARD_SIZE} sx={ADDRESS_CARD_SX}>
      <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={
            <Avatar icon={<AddLocationIcon />} label={newAddressString} />
          }
          css={css`
            .MuiCardHeader-action {
              display: contents;
            }
          `}
        />
        <CardMedia
          alt={newAddressString}
          component="img"
          height={DEFAULT_STATIC_MAP_HEIGHT}
          image={imageUrl}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography color="text.secondary" variant="body2">
            {newAddressString}
          </Typography>
        </CardContent>
        <CardActions>
          <Button onClick={handleStartCreate} size="medium" variant="outlined">
            Formulaire
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
};
